/**
 * Join socrative url
 */
export const joinSocrativeURL = window.APP_CONFIG.JOIN_URL;
